import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Sparkles } from 'lucide-react';

const BookAgainPanel = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const kycApproved = user?.kyc?.status === 'approved';

  return (
    <div className="bg-white p-6 rounded-lg shadow max-w-lg space-y-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-primary-dark flex items-center justify-center shrink-0">
          <Sparkles className="text-accent-light" size={22} />
        </div>
        <div>
          <h3 className="font-semibold text-dim">Ready for your next session?</h3>
          <p className="text-sm text-gray-500">Verified therapists, at home, in a hotel, or a partner spa.</p>
        </div>
      </div>

      {!kycApproved && (
        <p className="text-xs bg-amber-50 text-amber-700 p-2.5 rounded-lg">
          Tip: submitting your ID under the KYC tab helps us match you faster and keeps therapists safe too.
        </p>
      )}

      <button
        onClick={() => navigate('/book-massage')}
        className="w-full bg-primary-dark text-secondary py-3 rounded-lg font-medium hover:bg-accent-hard hover:text-primary-dark"
      >
        Book a massage
      </button>
    </div>
  );
};

export default BookAgainPanel;
